import { get, del } from '../../../utils/api';

export default {
  getCards: () => get({ url: 'user-card/list' }),
  deleteCard: card_id => del({ url: 'user-card/delete', data: { card_id } }),
};
